import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";

export const configurationLineRestClient = new RestClient(
  atmoClient,
  "configurationlines"
);
